<template>
  <div id="modalClosedOrder" class="modal fade" aria-hidden="true">
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical-center modal-md"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("rm.关闭采购单") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <div class="row form-group align-items-center mg-b-5">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("distributor.采购单号：") }}</label
            >
            <div class="col-md-10 col-sm-12">{{ item.code }}</div>
          </div>
          <div class="row form-group align-items-center mg-b-5">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("order.总价") }}:&nbsp;&nbsp;</label
            >
            <div class="col-md-10 col-sm-12">
              {{
                item.itemAmount
                  ? ($CE[item.currency] || {}).symbol +
                    Number(item.itemAmount).toFixed(2)
                  : 0
              }}
            </div>
          </div>
          <div class="row form-group align-items-center mg-b-5">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("rm.当前状态：") }}</label
            >
            <div class="col-md-10 col-sm-12">
              {{ (($parent.rmStatus || {})[item.status] || {}).name }}
            </div>
          </div>
          <div class="row form-group align-items-center mg-b-5">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("distributor.备注：")
              }}<span class="tx-danger">*</span></label
            >
            <div class="col-md-10 col-sm-12">
              <textarea
                rows="3"
                id="iptPriceRemark"
                class="form-control"
                :placeholder="$t('rm.请填写备注')"
                v-model="remark"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("distributor.提交") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("distributor.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      remark: "",
    };
  },
  mounted() {
    $("#modalClosedOrder").on("hidden.bs.modal", (e) => {
      this.remark = "";
    });
  },
  methods: {
    save() {
      if (!this.remark) return ShowTip(this.$t("rm.请填写备注"), "danger");
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierPurchaseOrder.closeBySupplier",
        {
          code: this.item.code,
          remark: this.remark,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("rm.关闭成功"), "success");
            $("#modalClosedOrder").modal("hide");
            setTimeout(() => {
              vm.$parent.getRMOrder(true);
              vm.$parent.getRMStatusNum();
            }, 2000);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
  },
};
</script>